/**
 * file : Sidbar.jsx
 * 설명 : 사이드 바
 */

import Evo from "assets/images/brand-icon-evo.png"
import Pragmatic from "assets/images/brand-icon-PRAGMATIC.png"
import Bng from "assets/images/brand-icon-BNG.png"
import Netent from "assets/images/brand-icon-NETENT.png"
import Icon1 from "assets/images/icon2.png"
import Icon2 from "assets/images/icon3.png"
import Icon3 from "assets/images/icon4.png"

export default function Sidbar() {
  return (
    <div className="quick_left">
      <div className="tmt">
        <h2>TMT<br />Progress</h2>
        <div className="list_tmt">
          <div>
            <span>
              <svg id="Isolation_Mode" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440.556 1428.141">
              <path className="brand_icon" d="M542.683,0H113.841C51.073,0,0,51.045,0,113.797v428.86c0,62.752,51.073,113.825,113.841,113.825h428.842c62.752,0,113.811-51.073,113.811-113.825V113.797c0-62.752-51.059-113.797-113.811-113.797ZM535.989,535.977H120.505V120.505h415.484v415.473Z"/><path className="brand_icon" d="M897.842,0c-62.768,0-113.841,51.045-113.841,113.797v428.86c0,62.752,51.073,113.825,113.841,113.825h428.842c62.782,0,113.872-51.073,113.872-113.825V113.797c0-62.752-51.09-113.797-113.872-113.797h-428.842ZM1320.051,535.977h-415.546V120.505h415.546v415.473Z"/><path className="brand_icon" d="M542.683,771.663H113.841c-62.768,0-113.841,51.04-113.841,113.792v428.828c0,62.785,51.073,113.858,113.841,113.858h428.842c62.752,0,113.811-51.073,113.811-113.858v-428.828c0-62.752-51.059-113.792-113.811-113.792ZM535.989,1307.636H120.505v-415.468h415.484v415.468Z"/><path className="brand_icon" d="M897.842,1428.141h428.842c62.782,0,113.872-51.073,113.872-113.858v-428.828c0-62.752-51.09-113.792-113.872-113.792h-428.842c-62.768,0-113.841,51.04-113.841,113.792v428.828c0,62.785,51.073,113.858,113.841,113.858ZM904.505,892.168h415.546v415.468h-415.546v-415.468Z"/></svg>
            </span>
            <p className="font_style1">All</p>
          </div>
          <div className="ing_">
            <div className="tip">TMT 진행중</div>
            <span><img src={Evo} alt="" /></span>
          </div>
          <div>
            <span><img src={Pragmatic} alt="" /></span>
          </div>
          <div className="ing_">
            <div className="tip">TMT 진행중</div>
            <span><img src={Bng} alt="" /></span>
          </div>
          <div>
            <span><img src={Netent} alt="" /></span>
            <p>NETENT</p>
          </div>
        </div>
      </div>
      <div className="total">
        <ul>
          <li>
            <a href="#">
              <p><img src={Icon1} alt="명예의 전당" /></p>
              <p>명예의<br />전당</p>
            </a>
          </li>
          <li>
            <a href="#">
              <p><img src={Icon2} alt="당첨자" /></p>
              <p>당첨자</p>
            </a>
          </li>
          <li>
            <a href="#">
              <p><img src={Icon3} alt="온라인 플레이어" /></p>
              <p>온라인<br />플레이어</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  )
}   